import AgentSyncLogo from '../assets/AgentSync'

const agentSync = {
  getImage: (props) => <AgentSyncLogo className="agent-sync" {...props} />,
  getURL: (variant) => 'https://www.agentsync.io',
}

export default agentSync
